@if (edge) {
  <oe-navigation-view>
    <ion-buttons header class="ion-justify-content-center">
      <div #ref><ng-content select="[custom-pickdate]"></ng-content></div>
      @if (!ref.children.length) {
        <pickdate></pickdate>
      }
    </ion-buttons>
    <oe-time-of-use-detail-chart [isOnlyChart]="true">
    </oe-time-of-use-detail-chart>
  </oe-navigation-view>
}
